import { CaseWorker } from '../common';
import { LocationOrigin } from '../enums';
import { LocationCalculationDetail } from './location-calculation-detail';

export class LocationDetailView {
    public id: string;
    public number: string;
    public name: string;
    public region: number;
    public origin: LocationOrigin;
    public caseWorker: CaseWorker;

    public isLandfill: boolean;
    public locationPollutionStatusDescription: string;

    public approvedCalculations: Array<LocationCalculationDetail>;
    public unapprovedCalculations: Array<LocationCalculationDetail>;
    public v1Calculations: Array<LocationCalculationDetail>;
    public screeningResults: Array<LocationCalculationDetail>;
    public preliminaryResults: Array<LocationCalculationDetail>;
    public preliminaryCalculations: Array<LocationCalculationDetail>;

    public constructor(init: Partial<LocationDetailView>) {
        Object.assign(this, init);
    }
}
